import React, { useState, useEffect } from "react";
import { Button, TextField, Typography, Container, Alert } from "@mui/material";
import { useGetUserByEmailQuery } from "../../api/useGetUserByEmail";

const CheckEmail = ({ user, setUser, emailConfirmed, setEmailConfirmed }) => {
  const [email, setEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [checkEmailEnabled, setCheckEmailEnabled] = useState(false);

  const { data, isLoading, isError, error } = useGetUserByEmailQuery(
    email,
    checkEmailEnabled
  );
  useEffect(() => {
    if (data) {
      // 서버에서 이메일 확인 성공 응답을 받은 경우
      setEmailConfirmed(true);
      setUser(data.user);
      setErrorMessage("");
    }

    if (isError) {
      // 서버에서 이메일 확인 실패 응답을 받은 경우
      setEmailConfirmed(false);
      setErrorMessage(
        error.response.data.error ||
          "이메일 인증에 실패했습니다. 다시 시도해주세요"
      );
    }
    setCheckEmailEnabled(false);
  }, [data, isError, error]);
  const handleEmailChange = (event) => {
    setEmail(event.target.value.trim());
    setCheckEmailEnabled(false);
    setEmailConfirmed(false); // Reset email confirmed status on email change
    setErrorMessage("");
  };

  const handleConfirmEmail = () => {
    setCheckEmailEnabled(true);
  };

  return (
    <div>
      <TextField
        margin="normal"
        required
        fullWidth
        id="email"
        label="이메일 주소"
        name="email"
        autoComplete="email"
        autoFocus
        value={email}
        onChange={handleEmailChange}
        error={!!errorMessage}
        helperText={errorMessage}
      />
      {isLoading ? (
        <div>loading</div>
      ) : (
        <Button
          variant="contained"
          onClick={handleConfirmEmail}
          sx={{ mt: 2, mb: 2 }}
        >
          이메일 확인
        </Button>
      )}
      {emailConfirmed && (
        <Typography sx={{ mb: 2 }}>이메일 확인 완료: {user?.name}</Typography>
      )}
    </div>
  );
};

export default CheckEmail;
